import * as type from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    searchMeta: null,
    filters: [],
    lastQuery: null,
};

const getters = {
    filters(state) {
        return state.filters;
    },
};

const mutations = {
    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },

    setFilters(state, filters) {
        state.filters = filters;
    },

    setLastQuery(state, query) {
        state.lastQuery = query;
    },
};

const actions = {
    getSearchMeta({ commit, dispatch }) {
        startLoading(dispatch, 'get-hourly-meta');

        return axios
            .get(Laroute.route('franchise.report.hourly.search.meta'))
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-hourly-meta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-hourly-meta');
                throw err;
            });
    },

    getSearchMetaIfNecessary({ dispatch }) {
        if (!state.searchMeta) {
            return dispatch('getSearchMeta');
        }

        return Promise.resolve(state.searchMeta);
    },

    getSearchMetaV2({ commit, dispatch }) {
        startLoading(dispatch, 'get-hourly-meta');

        return axios
            .get(Laroute.route('franchise.report.hourly.search.meta.V2'))
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-hourly-meta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-hourly-meta');
                throw err;
            });
    },

    getSearchMetaIfNecessaryV2({ dispatch }) {
        if (!state.searchMeta) {
            return dispatch('getSearchMetaV2');
        }

        return Promise.resolve(state.searchMeta);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
